/**
 * Cross-cutting constants shared by backend and every frontend.
 * Single source of truth — never hardcode these values elsewhere.
 */
export const TICKET_QR_PREFIX = "EVKA-TKT-V1:";
export const JWT_ISSUER = "elternverein-kaiseraugst.ch";
export const JWT_AUDIENCE = "event-tickets";
export const JWT_ALGORITHM = "ES256";
// ── CWT / COSE_Sign1 / base45 (replaces JWT for QR codes) ──
export const CWT_PREFIX = "EKTK1";
export const CWT_ISSUER = "EVK";
export const CWT_AUDIENCE = "event-tickets";
/** COSE algorithm registry value for ES256 (ECDSA w/ SHA-256 on P-256). */
export const CWT_ALG_ES256 = -7;
/** CBOR tag 18 = COSE_Sign1 (RFC 9052 §4.2). */
export const COSE_SIGN1_TAG = 18;
/** Standard CWT claim keys (RFC 8392 §4). */
export const CWT_CLAIM = {
    IAT: 6,
    CTI: 7,
};
/** Private-use claim keys (negative ints per CWT convention). */
export const CWT_PRIVATE_CLAIM = {
    EVENT_ID: -1,
    EVENT_DATE_DAYS: -2,
    CATEGORY: -3,
    PRICE_WORTH: -4,
    CURRENCY: -5,
    ISSUED_BY: -6,
    IS_TEST: -7,
};
/** COSE header parameters (RFC 9052 §3.1). */
export const COSE_HEADER = {
    ALG: 1,
    KID: 4,
};
export const CURRENCY_CODE = {
    CHF: 1,
    EUR: 2,
};
/** Calendar-date anchor for compact event_date_days encoding.
 *  Value = days since this date in the Europe/Zurich calendar. */
export const EVENT_DATE_EPOCH = "2026-01-01";
export const TYPEID_PREFIX = {
    transaction: "tx",
    ticket: "ticket",
    audit: "audit",
    anomaly: "anomaly",
};
export const PRICE_CATEGORIES = [
    "adult_member",
    "adult_nonmember",
    "child_member",
    "child_nonmember",
];
export const COMP_CATEGORIES = ["sponsor", "other"];
export const WORKSPACE_DOMAIN = "elternverein-kaiseraugst.ch";
/** Public association website — target of the buy page's "Zurück zur Website" button. */
export const ASSOCIATION_WEBSITE_URL = "https://www.elternverein-kaiseraugst.ch";
/**
 * The website's event page — target of the buy page's "Zurück zur
 * Event-Webseite" buttons AND the "Alle Informationen zum Anlass" link in the
 * delivery email. Site-structure content, not config: update when the
 * website gets a page for a new event.
 */
export const EVENT_INFO_URL = "https://www.elternverein-kaiseraugst.ch/veranstaltungen/open-air-kinderkino";
export const CURRENCY = "CHF";
export const DECIMAL_STRING_REGEX = /^\d+\.\d{2}$/;
export const EVENT_ID_REGEX = /^[a-z0-9](?:[a-z0-9-]{0,62}[a-z0-9])?$/;
//# sourceMappingURL=constants.js.map